/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationDocumentApprovalPeople200,
  GetApiV1CourseregistrationDocumentApprovalPeople400,
  GetApiV1CourseregistrationDocumentApprovalPeople401,
  GetApiV1CourseregistrationDocumentApprovalPeople500,
  GetApiV1CourseregistrationDocumentApprovalPeopleQueryParams,
  GetApiV1CourseregistrationDocumentApprovalPeopleQueryResponse,
} from "../../types/courseRegistrationDocumentApprovalController/GetApiV1CourseregistrationDocumentApprovalPeople.ts";
import { personDocumentApprovalListItemViewModelPaginatedResponseSchema } from "../personDocumentApprovalListItemViewModelPaginatedResponseSchema.ts";

export const getApiV1CourseregistrationDocumentApprovalPeopleQueryParamsSchema =
  z.object({
    classStudents: z.optional(z.array(z.coerce.number().int())),
    poleId: z.optional(z.coerce.number().int()),
    personId: z.optional(z.coerce.number().int()),
    enrollmentStatus: z.optional(z.array(z.coerce.number().int())),
    documentationStatus: z.optional(z.array(z.coerce.number().int())),
    associatedCompanyOnly: z.boolean().default(false),
    studentType: z.optional(z.coerce.number().int()),
    page: z.coerce.number().int().default(1),
  }) as unknown as ToZod<GetApiV1CourseregistrationDocumentApprovalPeopleQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationDocumentApprovalPeople200Schema = z.lazy(
  () => personDocumentApprovalListItemViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1CourseregistrationDocumentApprovalPeople200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1CourseregistrationDocumentApprovalPeople400Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationDocumentApprovalPeople400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationDocumentApprovalPeople401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationDocumentApprovalPeople401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationDocumentApprovalPeople500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationDocumentApprovalPeople500>;

export const getApiV1CourseregistrationDocumentApprovalPeopleQueryResponseSchema =
  z.lazy(
    () => getApiV1CourseregistrationDocumentApprovalPeople200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationDocumentApprovalPeopleQueryResponse>;
